import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import Notification from '../../Notification/Notification';
import PlanService from '../../../services/PlanService';
import Loader from '../../Loader/Loader';
import PageHeader from '../../PageHeader/PageHeader';
import ChangeSpeedTile from './ChangeSpeedTile';
import ChangeInProgressTile from './ChangeInProgressTile';
import MoveAddressTile from './MoveAddressTile';
import NotConnectedTile from './NotConnectedTile';
import LineTestTile from './LineTestTile';
import CustomerDetailsTile from './CustomerDetailsTile';
import ErrorTile from './ErrorTile';
import Covid19Tile from './Covid19Tile';
import './Dashboard.scss';
import cc from './cc.svg';
import kumoKane from './kumo-okane.svg';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    // Clear all customer data cached in Redux when this component is loaded.
    this.props.resetPlanData();
    this.props.resetAddressSearch();
    this.props.resetFormData();
    // Get customer data or log customer out if session has expired.
    this.props.checkSession();
  }

  componentDidMount() {
    this.props.storeStaticConfig();
  }

  componentWillUnmount() {
    this.props.clearAllDashboardNotifications();
  }

  render() {
    const { customerInfo, plans, isCovid19Mode, hasError, error } = this.props;
    const hasNoPlans = !PlanService.hasPlanData(plans);
    const hasPlans = PlanService.hasPlanData(plans);
    const hasNoData = (!customerInfo.firstName && hasNoPlans && !hasError);
    const defaultChangeCardTtile = 'Credit card details';
    const changeCardMaintenanceMessage = 'Temporarily unavailable, please check back later.';
    const changeCardTitle = customerInfo.featuresChangeCardDisabled ? changeCardMaintenanceMessage : defaultChangeCardTtile;

    return (
      <main className="gray-background">
        <PageHeader title={`Hey ${customerInfo.firstName}`} />
        <div className="container">
          {hasNoData &&
          <div className="row">
            <div className="col-md-12">
              <div className="large-loading-container">
                <Loader />
              </div>
            </div>
          </div>
          }
          {!hasNoData &&
          <div className="row">
            <div className="col-md-6">
              <CustomerDetailsTile customerInfo={customerInfo} />
              <div className="account-action-tile">
                <img
                  src={kumoKane}
                  alt="Amount to pay"
                />
                <h4 className="dashboard-attribute-header">Amount to pay</h4>
                {this.props.payNowSuccess &&
                <Notification>
                  Your payment was successful.
                </Notification>
                }
                <p>${customerInfo.accountBalance}</p>
                <Button
                  onClick={() => {
                    if (customerInfo.featuresPayOutstandingDisabled) {
                      return;
                    }
                    browserHistory.push('/confirm-pay-now');
                  }}
                  disabled={customerInfo.accountBalance === 0 || customerInfo.featuresPayOutstandingDisabled}
                >
                  PAY BALANCE
                </Button>
              </div>
              <div className="account-action-tile">
                <img
                  src={cc}
                  alt="Credit card details"
                />
                <h4 className="dashboard-attribute-header">{changeCardTitle}</h4>
                {this.props.updatePaymentSuccess &&
                <Notification>
                  Your credit card has been updated successfully.
                </Notification>
                }
                <p>
                  {customerInfo.currentCardLastDigits ?
                    `**** **** **** ${customerInfo.currentCardLastDigits}` :
                    'Please log out and then log in to see the last 4 digits of your registered card.'
                  }
                </p>
                <Button
                  disabled={customerInfo.featuresChangeCardDisabled}
                  onClick={() => {
                    if (customerInfo.featuresChangeCardDisabled) {
                      return;
                    }
                    browserHistory.push('/update-payment');
                  }}
                >
                  CHANGE CARD
                </Button>
              </div>
            </div>
            <div className="col-md-6">
              {hasNoPlans && customerInfo.connected && !hasError &&
              <div className="large-loading-container">
                <Loader />
              </div>
              }
              <ErrorTile hasError={hasError} error={error} />
              <NotConnectedTile customerInfo={customerInfo} hasError={hasError} />
              {hasPlans &&
              <div>
                <ChangeInProgressTile customerInfo={customerInfo} />
                {isCovid19Mode &&
                <Covid19Tile customerInfo={customerInfo} />
                }
                <ChangeSpeedTile customerInfo={customerInfo} plans={plans} hasError={hasError} />
                <MoveAddressTile customerInfo={customerInfo} />
                <LineTestTile customerInfo={customerInfo} />
              </div>
              }
            </div>
          </div>
          }
        </div>
      </main>
    );
  }
}

Dashboard.propTypes = {
  customerInfo: PropTypes.object,
  updatePaymentSuccess: PropTypes.bool,
  payNowSuccess: PropTypes.bool,
  clearAllDashboardNotifications: PropTypes.func,
  checkSession: PropTypes.func,
  resetPlanData: PropTypes.func,
  resetFormData: PropTypes.func,
  resetAddressSearch: PropTypes.func,
  plans: PropTypes.object,
  hasError: PropTypes.bool,
  error: PropTypes.object,
  storeStaticConfig: PropTypes.func,
  isCovid19Mode: PropTypes.bool
};

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/Dashboard.js
 **/